import { filter, isEmpty } from 'lodash';
import { GET_LOTS_DONE, ADD_LOT_DONE, EDIT_LOT_DONE, GET_LOT_DONE, DELETE_LOT_DONE } from './constantsActions';
import axiosInstance from '../components/utils/axios/axiosInstance';

function getAllDone(lots) {
  return {
    type: GET_LOTS_DONE,
    payload: lots
  };
}

function addLotDone(lot) {
  return {
    type: ADD_LOT_DONE,
    payload: lot
  }
}

function editLotDone(lot) {
  return {
    type: EDIT_LOT_DONE,
    payload: lot
  }
}

function getLotDone(lot) {
  return {
    type: GET_LOT_DONE,
    payload: lot
  }
}

function deleteLotDone(id) {
  return {
    type: DELETE_LOT_DONE,
    payload: id
  }
}

export function getAllLots() {
  return async (dispatch, getState) => {
    const isAdmin = !isEmpty(filter(
      getState().auth.roles,
      (role) => role.name === 'ROLE_ADMIN' && role.active === true
    ));

    const { data } = await axiosInstance.get(`/api/parkingLot/all`, {
      params: {
        withPlacesOnly: !isAdmin // Pro admina stahujeme i prazda parkoviste
      }
    });

    dispatch(getAllDone(data));
    return data;
  };
}

export function addLot(lot) {
  return async (dispatch) => {
    const { data } = await axiosInstance.post(`/api/parkingLot/save`, {
      active: true,
      city: lot.city,
      countryCode: 'CS',
      latitude: lot.lat,
      longitude: lot.lng,
      name: lot.name,
      street: lot.street
    });

    dispatch(addLotDone(data));
  };
}


export function editLot(lot) {
  return async (dispatch) => {
    const { data } = await axiosInstance.post(`/api/parkingLot/save`, {
      id: lot.id,
      active: true,
      city: lot.city,
      countryCode: lot.countryCode,
      latitude: lot.lat,
      longitude: lot.lng,
      name: lot.name,
      street: lot.street
    });
  
    dispatch(editLotDone(data));
  };
}

export function getLot(id) {
  return async (dispatch) => {
    const { data } = await axiosInstance.get(`/api/parkingLot/findById`, {
      params: {id}
    });

    dispatch(getLotDone(data));
    return data;
  };
}

export function deleteLot(id) {
  return async (dispatch) => {
    await axiosInstance.post(`/api/parkingLot/delete`,{}, {
      params: {id}
    });

    dispatch(deleteLotDone(id));
  };
}